import {AlertIcon} from '../../../../../assets/icons/AlertIcon'
import styled from 'styled-components'

export const StyledAlertIconReset = styled(AlertIcon)`
    fill: none !important;
`
